export const CUSTOMER_AUTH_METHOD_ACTIONS = {
  LIST: 'CUSTOMER_AUTH_METHOD_LIST',
  VIEW: 'CUSTOMER_AUTH_METHOD_VIEW',
  UPDATE: 'CUSTOMER_AUTH_METHOD_UPDATE'
};